var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.isShowModel,
        width: "40%",
        "custom-class": "preview-dialog",
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        "append-to-body": true,
        top: "0",
        "destroy-on-close": true,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "preview-wrap",
          class: _vm.activeName === "pc" ? "pc" : "mobile",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName === "pc",
                  expression: "activeName === 'pc'",
                },
              ],
              staticClass: "preview-container",
            },
            [
              _c("div", { staticClass: "content-box-pc" }, [
                _c("div", {
                  staticClass: "ck-content",
                  domProps: { innerHTML: _vm._s(_vm.data) },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName === "mobile",
                  expression: "activeName === 'mobile'",
                },
              ],
              staticClass: "preview-container",
            },
            [
              _c("div", { staticClass: "frame-img" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-inner" },
                [
                  _c("el-scrollbar", [
                    _c("div", { staticClass: "content-box-mobile" }, [
                      _c("div", {
                        staticClass: "ck-content",
                        domProps: { innerHTML: _vm._s(_vm.data) },
                      }),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium" },
              on: {
                click: function ($event) {
                  _vm.isShowModel = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("sfe.noticeContent.dropdown.closePreview")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }